// src/components/serials/tags/extendedCards.js
import { cardFromSerial } from "./submitTagsFlow";
import { EXTENDED_ART_KIND } from "../../extendedArt/kind";

export const BLOCK_REASON_LABELS = {
  art_not_approved: "Arte não aprovada",
  flag_off: "Arte estendida desligada neste ambiente",
  mobile: "O gerador mobile não imprime arte estendida",
  art_unavailable: "Arte aprovada indisponível: confira o armazenamento das artes",
};

// Correção em revisão não tira da etiqueta a versão aprovada vigente: basta haver aprovada com URL.
const isApproved = (serial) => serial?.artLabel?.status === "approved" || Boolean(serial?.artLabel?.approved?.url);

const approvedArtOf = (serial) => {
  const art = serial?.artLabel;
  return isApproved(serial) && art?.approved?.url ? art : null;
};

/**
 * Cartão do gerador a partir de um ExtendedArtSerial (contrato 00): texto do
 * `gradableModel` (como no serial comum), `condition` no lugar da nota (D5) e a
 * arte gravada no próprio serial (D4) — nunca a arte atual do modelo.
 */
export const extendedCardFromSerial = (serial) => {
  const base = cardFromSerial(serial, {});
  const art = approvedArtOf(serial);
  return {
    ...base,
    kind: EXTENDED_ART_KIND,
    condition: serial?.condition || "",
    notaAutografo: serial?.notaAutografo === null || serial?.notaAutografo === undefined ? "" : String(serial.notaAutografo),
    invertida: false,
    art: art
      ? { artKey: art.artKey, version: art.approved.version, s3Key: art.approved.s3Key, url: art.approved.url, sourceUrl: art.thumbUrl || null }
      : null,
  };
};

/**
 * Ordem: mobile → flag_off → art_not_approved → art_unavailable. A última cobre
 * arte aprovada com `approved.url` null (backend sem bucket ou presign falhou, D23).
 */
export const blockReasonFor = (serial, { artEnabled, mobile }) => {
  if (mobile) return "mobile";
  if (!artEnabled) return "flag_off";
  if (!isApproved(serial)) return "art_not_approved";
  if (!approvedArtOf(serial)) return "art_unavailable";
  return null;
};

/** Estendido sem arte aprovada, com a flag desligada ou no mobile não é impresso (spec §5.4, D12). */
export const splitBlockedExtended = (serials, { artEnabled = false, mobile = false } = {}) => {
  const allowed = [];
  const blocked = [];
  for (const serial of serials || []) {
    const reason = blockReasonFor(serial, { artEnabled, mobile });
    if (!reason) {
      allowed.push(serial);
      continue;
    }
    blocked.push({
      serialNumber: serial.serialNumber,
      modelName: serial?.gradableModel?.name || "",
      artKey: serial?.artLabel?.artKey || null,
      reason,
    });
  }
  return { allowed, blocked };
};
